
export default {
    api: {
        //服务器地址
        domain:'https://evapi.smallzone.work',
        //api地址
        base_url:  'https://evapi.smallzone.work/admin/rpc',
        //请求超时时间（单位S）
        timeout: 1000,
    },

    login_websocket_url:  'https://evapi.smallzone.work:39898', 

    page: {
        //每页显示条数
        page_size: 30
    },

    //文件服务器地址
    upload_url: 'https://evapi.smallzone.work/admin/rpc',
    //文件服务器地址
    file_srv:'https://evapi.smallzone.work'
}

